document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const listItems = document.querySelectorAll(".buckscc-select-options .converterTriggers");
    console.log("Currency script initialized");

    listItems.forEach(function (item) {
      item.addEventListener("click", function () {
        console.log("Currency clicked: ", item.id);
        setTimeout(function () {
          location.reload();
        }, 500);
      });
    });
  }, 2000); // Wait 2 seconds before attaching click listeners

  function syncHeaderCartBubbleCount(itemCount) {
    const roots = document.querySelectorAll('[id="cart-icon-bubble"]');
    if (!roots.length) return;

    roots.forEach((root) => {
      let bubble = root.querySelector('.cart-count-bubble');

      if (!itemCount || itemCount <= 0) {
        if (bubble) bubble.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        root.appendChild(bubble);
      }

      let visibleCount = bubble.querySelector('span[aria-hidden="true"]');
      let srCount = bubble.querySelector('.visually-hidden');
      if (!visibleCount) {
        visibleCount = document.createElement('span');
        visibleCount.setAttribute('aria-hidden', 'true');
        bubble.prepend(visibleCount);
      }
      if (!srCount) {
        srCount = document.createElement('span');
        srCount.className = 'visually-hidden';
        bubble.appendChild(srCount);
      }

      visibleCount.textContent = String(itemCount);
      srCount.textContent = `Cart items: ${itemCount}`;
    });
  }

  function refreshHeaderCartBubbleGlobal(retryCount = 0) {
    return fetch(`/cart.js?_ts=${Date.now()}`, {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (!cart) return;
        const count = typeof cart.item_count === 'number' ? cart.item_count : 0;
        syncHeaderCartBubbleCount(count);
      })
      .catch(() => {
        if (retryCount > 0) {
          setTimeout(() => refreshHeaderCartBubbleGlobal(retryCount - 1), 250);
        }
      });
  }

  refreshHeaderCartBubbleGlobal(2);
  window.addEventListener('pageshow', function () {
    refreshHeaderCartBubbleGlobal(1);
  });








// Step 3/4 removed from flow; no interview skip handler needed.




  
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on the correct page
    const layout = document.querySelector('.content-for-layout');
    if (!layout) return;
    const experienceRoot = document.querySelector('.cstm-experience');
    if (!experienceRoot) return;

    const tabs = document.querySelectorAll('.tab');
    const serviceGroups = document.querySelectorAll('.service-group');
    const cartItemsContainer = document.getElementById('cart-items-container');
    const vatAmount = document.getElementById('vat-amount');
    const totalAmount = document.getElementById('total-amount');
    const checkoutButtons = document.querySelectorAll('.cstm-btn-checkout');
    const servicesBackButton = document.querySelector('.cstm-services-back');
    const uploadBackButton = document.querySelector('.cstm-upload-back');
    const uploadInput = document.getElementById('cstm-cv-upload-input');
    const uploadDropzone = document.querySelector('.cstm-upload-dropzone');
    const uploadFileNameLabel = document.querySelector('.cstm-upload-file-name');
    const experienceStepper = document.querySelector('.cstm-stepper');
    const experienceStepItems = experienceStepper ? Array.from(experienceStepper.querySelectorAll('.cstm-step')) : [];
    const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    let cartItems = [];
    let pendingItems = [];
    let uploadedCvFileName = '';
    let uploadedCvFile = null;
    let cartSyncQueue = Promise.resolve();
    let latestShopifyCart = null;

    // Set currentTab dynamically
    let currentTab = tabs.length > 0 ? 
        (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).getAttribute('data-target') : 
        'graduate';
    const proceedNextStepText = window.locale === 'ar' ? 'انتقل إلى الخطوة التالية' : 'Proceed to Next Step';
    const proceedCheckoutText = window.locale === 'ar' ? 'الشروع في الخروج' : 'Proceed to Checkout';

    function getExperienceFlowStep() {
        if (!layout.classList.contains('cstm-services-step')) return 1;
        if (!layout.classList.contains('cstm-upload')) return 2;
        return 3;
    }

    function updateExperienceStepper(explicitStep) {
        if (!experienceStepper || experienceStepItems.length === 0) return;
        const step = Math.max(1, Math.min(experienceStepItems.length, explicitStep || getExperienceFlowStep()));
        experienceStepper.style.setProperty('--active-step', String(step));
        experienceStepItems.forEach((item, index) => {
            const itemStep = index + 1;
            item.classList.toggle('is-active', itemStep === step);
            item.classList.toggle('is-complete', itemStep < step);
        });
    }

    if (experienceStepper) {
        const layoutObserver = new MutationObserver(() => updateExperienceStepper());
        layoutObserver.observe(layout, { attributes: true, attributeFilter: ['class'] });
    }

    if (uploadInput) {
        if (uploadDropzone) {
            uploadDropzone.addEventListener('click', function () {
                uploadInput.click();
            });
            uploadDropzone.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    uploadInput.click();
                }
            });
        }

        uploadInput.addEventListener('change', function () {
            const file = this.files && this.files[0] ? this.files[0] : null;
            if (!file) {
                uploadedCvFileName = '';
                uploadedCvFile = null;
                if (uploadFileNameLabel) {
                    uploadFileNameLabel.textContent = 'No file selected yet.';
                }
                if (uploadDropzone) {
                    uploadDropzone.classList.remove('has-file');
                }
                return;
            }

            const allowedExt = /\.(pdf|doc|docx)$/i;
            const maxSizeBytes = 10 * 1024 * 1024;
            if (!allowedExt.test(file.name)) {
                this.value = '';
                uploadedCvFileName = '';
                uploadedCvFile = null;
                if (uploadFileNameLabel) {
                    uploadFileNameLabel.textContent = 'Unsupported file type. Please upload PDF, DOC, or DOCX.';
                }
                if (uploadDropzone) {
                    uploadDropzone.classList.remove('has-file');
                }
                return;
            }
            if (file.size > maxSizeBytes) {
                this.value = '';
                uploadedCvFileName = '';
                uploadedCvFile = null;
                if (uploadFileNameLabel) {
                    uploadFileNameLabel.textContent = 'File is too large. Maximum allowed size is 10MB.';
                }
                if (uploadDropzone) {
                    uploadDropzone.classList.remove('has-file');
                }
                return;
            }

            uploadedCvFileName = file.name;
            uploadedCvFile = file;

            if (uploadFileNameLabel) {
                uploadFileNameLabel.textContent = uploadedCvFileName;
            }

            if (uploadDropzone) {
                uploadDropzone.classList.toggle('has-file', Boolean(uploadedCvFileName));
            }

            if (layout.classList.contains('cstm-upload')) {
                updateExperienceStepper(3);
            }
        });
    }

    // Inject loading spinner and cart styling CSS
    const style = document.createElement('style');
    style.textContent = `
        .loading-spinner {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            font-size: 14px;
            color: #333;
        }
        .loading-spinner::before {
            content: '';
            width: 20px;
            height: 20px;
            border: 3px solid #ccc;
            border-top: 3px solid #007bff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        .cart-experience-group {
            margin-bottom: 15px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
        }
        .cart-experience-heading {
            font-size: 16px;
            font-weight: bold;
            margin: 10px 0 5px;
            color: #333;
        }
        .cart-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 0;
        }
    `;
    document.head.appendChild(style);
    document.querySelector('.cstm-btn-checkout').addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    // Check URL for skip parameter
    const urlParams = new URLSearchParams(window.location.search);
    const skipParam = urlParams.get('skip');
    if (skipParam === 'step1') {
        layout.classList.add('cstm-services-step');
    } else if (skipParam === 'step2') {
        layout.classList.add('cstm-services-step', 'cstm-upload');
        checkoutButtons.forEach(btn => {
            btn.textContent = proceedCheckoutText;
        });
    }
    updateExperienceStepper();

    // Keep cart persistent across pages; do not clear the entire cart on page load.
    // Experience flow sync will only replace Experience-flow line items.
    localStorage.removeItem('experienceCart');
    cartItems = [];
    pendingItems = [];
    updateCart();
    refreshHeaderCartBubbleFromApi(1);

    async function clearExperienceFlowItems() {
        try {
            const cartRes = await fetch(`/cart.js?_ts=${Date.now()}`, {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!cartRes.ok) return;
            const cart = await cartRes.json();
            if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

            const updates = {};
            cart.items.forEach((item) => {
                const props = item && item.properties ? item.properties : {};
                const isExperienceItem = Boolean(
                    (props && props['Experience Level']) ||
                    (props && props['_ExperienceFlow'] === 'true')
                );
                if (isExperienceItem && item.key) {
                    updates[item.key] = 0;
                }
            });

            if (Object.keys(updates).length === 0) return;

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ updates })
            });
        } catch (error) {
            console.error('Error clearing Experience flow items:', error);
        }
    }

    async function syncUploadAttribute() {
        if (!uploadedCvFileName) return;
        try {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        'Uploaded CV filename': uploadedCvFileName
                    }
                })
            });
        } catch (error) {
            console.error('Error syncing upload attribute:', error);
        }
    }

    function redirectToCheckout() {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart';
        form.style.display = 'none';

        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';

        form.appendChild(checkoutInput);
        document.body.appendChild(form);
        form.submit();
    }

    function syncCartBubbleCount(itemCount) {
        const cartBubbleSelector = '[id="cart-icon-bubble"]';
        const roots = document.querySelectorAll(cartBubbleSelector);
        if (!roots.length) return;

        roots.forEach((cartBubbleRoot) => {
            let bubble = cartBubbleRoot.querySelector('.cart-count-bubble');

            if (!itemCount || itemCount <= 0) {
                if (bubble) bubble.remove();
                return;
            }

            if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
                cartBubbleRoot.appendChild(bubble);
            }

            let visibleCount = bubble.querySelector('span[aria-hidden="true"]');
            let srCount = bubble.querySelector('.visually-hidden');
            if (!visibleCount) {
                visibleCount = document.createElement('span');
                visibleCount.setAttribute('aria-hidden', 'true');
                bubble.prepend(visibleCount);
            }
            if (!srCount) {
                srCount = document.createElement('span');
                srCount.className = 'visually-hidden';
                bubble.appendChild(srCount);
            }
            visibleCount.textContent = String(itemCount);
            srCount.textContent = `Cart items: ${itemCount}`;
        });
    }

    async function refreshHeaderCartBubbleFromApi(retryCount = 0) {
        try {
            const response = await fetch(`/cart.js?_ts=${Date.now()}`, {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!response.ok) return null;
            const cart = await response.json();
            const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            syncCartBubbleCount(count);
            return cart;
        } catch (error) {
            if (retryCount > 0) {
                setTimeout(() => {
                    refreshHeaderCartBubbleFromApi(retryCount - 1);
                }, 250);
            }
            return null;
        }
    }

    async function refreshExperienceCartDrawer(triggerElement, triggerVariantId) {
        if (!cartUi) return;
        try {
            const response = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!response.ok) return;
            const sections = await response.json();

            if (cartUi.classList && cartUi.classList.contains('is-empty')) {
                cartUi.classList.remove('is-empty');
            }

            if (typeof cartUi.setActiveElement === 'function' && triggerElement) {
                cartUi.setActiveElement(triggerElement);
            }

            if (typeof cartUi.renderContents === 'function') {
                cartUi.renderContents({
                    id: triggerVariantId || '',
                    sections: sections || {}
                });
            } else if (typeof cartUi.open === 'function') {
                cartUi.open(triggerElement || undefined);
            }
        } catch (error) {
            if (typeof cartUi.open === 'function') {
                cartUi.open(triggerElement || undefined);
            }
        }
    }

    function queueCartSync(options = {}) {
        cartSyncQueue = cartSyncQueue
            .then(() => syncCartWithShopify(options))
            .catch((error) => {
                console.error('Queued cart sync failed:', error);
                return null;
            });
        return cartSyncQueue;
    }

    function determineStepFromVariant(variantId) {
        const serviceItems = document.querySelectorAll('.service-item');
        if (Array.from(serviceItems).some(item => item.getAttribute('data-variant-id') === variantId)) {
            return 'services';
        }
        return 'unknown';
    }

    function readBubbleCountFromDom() {
        const root = document.querySelector('[id="cart-icon-bubble"]');
        if (!root) return 0;
        const bubble = root.querySelector('.cart-count-bubble');
        if (!bubble) return 0;
        const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        if (!visibleCount) return 0;
        const parsed = parseInt((visibleCount.textContent || '').trim(), 10);
        return Number.isNaN(parsed) ? 0 : parsed;
    }

    function optimisticBubbleAdjust(delta) {
        const current = readBubbleCountFromDom();
        const next = Math.max(0, current + delta);
        syncCartBubbleCount(next);
    }

    async function refreshCartDrawerSectionSilent(retryCount = 0) {
        if (!cartUi) return;
        try {
            const response = await fetch('/?sections=cart-drawer', {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!response.ok) return;
            const sections = await response.json();
            const drawerSectionHtml = sections && sections['cart-drawer'] ? sections['cart-drawer'] : '';
            if (!drawerSectionHtml) return;

            const parsed = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
            const newCartDrawer = parsed.querySelector('#CartDrawer');
            const currentCartDrawer = document.querySelector('#CartDrawer');
            if (newCartDrawer && currentCartDrawer) {
                currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
            }

            if (cartUi.classList) {
                const hasItems = latestShopifyCart && Array.isArray(latestShopifyCart.items) && latestShopifyCart.items.length > 0;
                cartUi.classList.toggle('is-empty', !hasItems);
            }

            const overlay = cartUi.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof cartUi.close === 'function') {
                overlay.addEventListener('click', cartUi.close.bind(cartUi));
            }
        } catch (error) {
            if (retryCount > 0) {
                setTimeout(() => {
                    refreshCartDrawerSectionSilent(retryCount - 1);
                }, 250);
            }
        }
    }

    async function addExperienceVariantToCart(variantId, experience, triggerElement) {
        if (!variantId) return null;
        optimisticBubbleAdjust(1);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        if (experience) {
            formData.append('properties[Experience Level]', experience);
        }
        formData.append('properties[_ExperienceFlow]', 'true');

        if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
            formData.append(
                'sections',
                cartUi.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
        }

        const requestConfig = (typeof fetchConfig === 'function')
            ? fetchConfig('javascript')
            : { method: 'POST', headers: {} };
        requestConfig.headers = requestConfig.headers || {};
        requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        if (requestConfig.headers['Content-Type']) delete requestConfig.headers['Content-Type'];
        requestConfig.body = formData;

        try {
            const response = await fetch(
                (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js',
                requestConfig
            );
            const payload = await response.json();
            if (payload && payload.status) throw new Error(payload.description || 'Unable to add item');
        } catch (error) {
            console.error('Add experience variant failed:', error);
        } finally {
            await refreshMiniCartFromShopify(2);
            await refreshCartDrawerSectionSilent(1);
            refreshHeaderCartBubbleFromApi(2);
        }
    }

    async function removeExperienceVariantFromCart(variantId, options = {}) {
        const { openDrawer = false, triggerElement = null } = options;
        if (!variantId) return;
        optimisticBubbleAdjust(-1);
        try {
            const cartRes = await fetch(`/cart.js?_ts=${Date.now()}`, {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!cartRes.ok) return;
            const cart = await cartRes.json();
            const targetItems = (cart.items || []).filter((item) => {
                const props = item && item.properties ? item.properties : {};
                return Number(item.variant_id) === Number(variantId) && props && props['_ExperienceFlow'] === 'true';
            });
            for (const item of targetItems) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: 0
                    })
                });
            }
            if (openDrawer) {
                openAndRefreshDrawerFromPayload(null, triggerElement, variantId);
            }
        } catch (error) {
            console.error('Remove experience variant failed:', error);
        } finally {
            await refreshMiniCartFromShopify(2);
            await refreshCartDrawerSectionSilent(1);
            refreshHeaderCartBubbleFromApi(2);
        }
    }

    async function removeDistributionExperienceVariants(options = {}) {
        const { openDrawer = false, triggerElement = null } = options;
        const distributionVariantIds = Array.from(document.querySelectorAll('.distribution-radio'))
            .map((radio) => radio.getAttribute('data-variant-id'))
            .filter(Boolean);
        if (!distributionVariantIds.length) return;
        try {
            const cartRes = await fetch(`/cart.js?_ts=${Date.now()}`, {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!cartRes.ok) return;
            const cart = await cartRes.json();
            const targetItems = (cart.items || []).filter((item) => {
                const props = item && item.properties ? item.properties : {};
                return distributionVariantIds.includes(String(item.variant_id)) && props && props['_ExperienceFlow'] === 'true';
            });
            for (const item of targetItems) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: 0
                    })
                });
            }
            if (openDrawer) {
                openAndRefreshDrawerFromPayload(null, triggerElement, null);
            }
        } catch (error) {
            console.error('Remove distribution variants failed:', error);
        } finally {
            await refreshMiniCartFromShopify(2);
            await refreshCartDrawerSectionSilent(1);
            refreshHeaderCartBubbleFromApi(2);
        }
    }

    // Sync pending items with Shopify cart
    async function syncCartWithShopify(options = {}) {
        const {
            openDrawer = false,
            triggerElement = null,
            triggerVariantId = null
        } = options;
        try {
            await clearExperienceFlowItems();
            for (let index = 0; index < pendingItems.length; index++) {
                const item = pendingItems[index];
                const attachUploadedCv = Boolean(uploadedCvFile) && index === 0;

                if (attachUploadedCv) {
                    const formData = new FormData();
                    formData.append('id', item.variantId);
                    formData.append('quantity', '1');
                    if (item.experience) {
                        formData.append('properties[Experience Level]', item.experience);
                    }
                    formData.append('properties[_ExperienceFlow]', 'true');
                    formData.append('properties[Uploaded CV]', uploadedCvFile, uploadedCvFile.name);

                    const uploadResponse = await fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData
                    });
                    if (!uploadResponse.ok) {
                        throw new Error('Failed to add uploaded CV line item to cart.');
                    }
                } else {
                    const addResponse = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: item.variantId,
                            quantity: 1,
                            properties: item.experience
                                ? { 'Experience Level': item.experience, '_ExperienceFlow': 'true' }
                                : { '_ExperienceFlow': 'true' }
                        })
                    });
                    if (!addResponse.ok) {
                        throw new Error('Failed to add line item to cart.');
                    }
                }
            }
            const response = await fetch('/cart.js');
            if (!response.ok) {
                throw new Error('Failed to read Shopify cart after sync.');
            }
            const cart = await response.json();
            var activeCurrency = document.querySelector('.bucks-selected').innerText;
            cartItems = cart.items.map(item => ({
                variantId: item.variant_id.toString(),
                name: item.product_title,
                price: item.price / 100,
                priceFormatted: `${activeCurrency} ${(item.price / 100).toFixed(2)}`,
                experience: (item.properties && item.properties['Experience Level']) ? item.properties['Experience Level'] : '',
                step: item.step || determineStepFromVariant(item.variant_id.toString())
            }));
            localStorage.setItem('experienceCart', JSON.stringify(cartItems));
            updateCart();
            await refreshHeaderCartBubbleFromApi(2);
            if (openDrawer) {
                await refreshExperienceCartDrawer(triggerElement, triggerVariantId);
            }
            return cart;
        } catch (error) {
            console.error('Error syncing with Shopify cart:', error);
            updateCart();
            await refreshHeaderCartBubbleFromApi(1);
            return null;
        }
    }

    function formatMoneyFromCents(cents) {
        const value = (Number(cents || 0) / 100);
        const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
        const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;
        return `${currencySymbol} ${value.toFixed(2)}`;
    }

    async function removeMiniCartLineItem(lineKey, variantId) {
        if (!lineKey) return;
        showLoadingSpinner();
        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: lineKey,
                    quantity: 0
                })
            });

            if (variantId) {
                pendingItems = pendingItems.filter(item => String(item.variantId) !== String(variantId));
                localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
                document.querySelectorAll(`.service-select-checkbox[data-variant-id="${variantId}"]`).forEach(cb => {
                    cb.checked = false;
                });
                document.querySelectorAll(`.distribution-radio[data-variant-id="${variantId}"]`).forEach(rb => {
                    rb.checked = false;
                });
                syncDistributionRadios();
            }
            await refreshMiniCartFromShopify(2);
            await refreshHeaderCartBubbleFromApi(2);
        } catch (error) {
            console.error('Failed to remove line item from mini cart:', error);
            await refreshMiniCartFromShopify(1);
            await refreshHeaderCartBubbleFromApi(1);
        }
    }

    function renderMiniCartFromShopify(cart) {
        if (!cartItemsContainer) return;
        cartItemsContainer.innerHTML = '';

        const items = cart && Array.isArray(cart.items) ? cart.items : [];
        if (!items.length) {
            const emptyState = document.createElement('div');
            emptyState.className = 'cart-experience-group';
            emptyState.innerHTML = `<div class="cart-experience-heading">${window.locale === 'ar' ? 'السلة فارغة' : 'Cart is empty'}</div>`;
            cartItemsContainer.appendChild(emptyState);
        } else {
            const groupedItems = {};
            items.forEach((item) => {
                const props = item && item.properties ? item.properties : {};
                const group = props['Experience Level'] || (window.locale === 'ar' ? 'سلة التسوق' : 'Cart');
                if (!groupedItems[group]) groupedItems[group] = [];
                groupedItems[group].push(item);
            });

            Object.keys(groupedItems).forEach((group) => {
                const groupContainer = document.createElement('div');
                groupContainer.className = 'cart-experience-group';

                const heading = document.createElement('div');
                heading.className = 'cart-experience-heading';
                heading.textContent = group;
                groupContainer.appendChild(heading);

                groupedItems[group].forEach((item) => {
                    const linePriceCents = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
                    const cartItemElement = document.createElement('div');
                    cartItemElement.className = 'cart-item';
                    cartItemElement.innerHTML = `
                    <span>${item.product_title}</span>
                    <span class="cart-item-qty">x${item.quantity}</span>
                    <span class="price money buckscc-converted buckscc-money">${formatMoneyFromCents(linePriceCents)}</span>
                    <button class="remove-item" data-line-key="${item.key}" data-variant-id="${item.variant_id}">×</button>
                `;
                    groupContainer.appendChild(cartItemElement);
                });

                cartItemsContainer.appendChild(groupContainer);
            });
        }

        const totalCents = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        const total = totalCents / 100;
        const vat = total * 0.05 / 1.05;

        const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
        const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;

        const installmentSpans = document.querySelectorAll('.cstm_installment');
        const totalInstallment = total / 4;
        installmentSpans.forEach(span => {
            span.innerHTML = `${currencySymbol} ${totalInstallment.toFixed(1)}/month`;
        });

        if (vatAmount) {
            vatAmount.textContent = `${currencySymbol} ${vat.toFixed(2)}`;
        }
        if (totalAmount) {
            totalAmount.textContent = `${currencySymbol} ${total.toFixed(2)}`;
        }

        document.querySelectorAll('.remove-item').forEach(button => {
            button.addEventListener('click', function() {
                const lineKey = this.getAttribute('data-line-key');
                const variantId = this.getAttribute('data-variant-id');
                removeMiniCartLineItem(lineKey, variantId);
            });
        });
    }

    async function refreshMiniCartFromShopify(retryCount = 0) {
        try {
            const response = await fetch(`/cart.js?_ts=${Date.now()}`, {
                headers: { 'Accept': 'application/json' },
                cache: 'no-store',
                credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('Failed to load cart');
            const cart = await response.json();
            latestShopifyCart = cart;
            renderMiniCartFromShopify(cart);
            await refreshCartDrawerSectionSilent(1);
            return cart;
        } catch (error) {
            if (retryCount > 0) {
                setTimeout(() => {
                    refreshMiniCartFromShopify(retryCount - 1);
                }, 250);
            }
            return null;
        }
    }

    function showLoadingSpinner() {
        const spinner = document.createElement('div');
        spinner.className = 'loading-spinner';
        spinner.textContent = 'Updating cart...';
        cartItemsContainer.innerHTML = '';
        cartItemsContainer.appendChild(spinner);
    }

    function updateCart() {
        if (latestShopifyCart) {
            renderMiniCartFromShopify(latestShopifyCart);
            return;
        }
        refreshMiniCartFromShopify(1);
    }

    function syncServiceCheckboxes() {
        document.querySelectorAll('.service-select-checkbox:not(.distribution-master-checkbox)').forEach(checkbox => {
            const variantId = checkbox.getAttribute('data-variant-id');
            checkbox.checked = pendingItems.some(item => item.variantId === variantId && item.step === 'services');
        });
    }
    function syncDistributionRadios() {
        const selectedDistribution = pendingItems.find(item => item.step === 'services' && item.serviceKind === 'distribution');
        document.querySelectorAll('.distribution-radio').forEach(radio => {
            const variantId = radio.getAttribute('data-variant-id');
            radio.checked = Boolean(selectedDistribution && variantId && selectedDistribution.variantId === variantId);
        });
        syncDistributionMasterCheckboxes();
    }
    function syncDistributionMasterCheckboxes() {
        document.querySelectorAll('.service-item.service-distribution-options').forEach(distributionItem => {
            const masterCheckbox = distributionItem.querySelector('.distribution-master-checkbox');
            if (!masterCheckbox) return;
            const hasCheckedPackage = Array.from(distributionItem.querySelectorAll('.distribution-radio')).some(radio => radio.checked);
            masterCheckbox.checked = hasCheckedPackage;
        });
    }

    // Tab switching for experience levels
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('selected'));
            tab.classList.add('selected');

            serviceGroups.forEach(group => group.classList.remove('active'));
            const target = tab.getAttribute('data-target');
            document.getElementById(target).classList.add('active');
            currentTab = target;

            updateCart();
            syncServiceCheckboxes();
            syncDistributionRadios();
        });
    });

    // Add/Remove pending items for Services (Step 2) using checkboxes
    document.querySelectorAll('.service-select-checkbox:not(.distribution-master-checkbox)').forEach(checkbox => {
        checkbox.addEventListener('change', async function() {
            const variantId = this.getAttribute('data-variant-id');
            const productItem = this.closest('.service-item');
            const productName = productItem.querySelector('.service-name').textContent;
            const productPrice = productItem.querySelector('.price').textContent;
            const productPriceCents = Number(productItem.getAttribute('data-price-cents') || 0);
            const serviceCategory = productItem.getAttribute('data-service-category') || 'addon';
            const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
            const priceValue = productPriceCents > 0 ? (productPriceCents / 100) : parseCurrencyValue(productPrice, activeCurrency);

            if (!variantId) return;

            showLoadingSpinner();

            if (this.checked) {
                if (!pendingItems.some(item => item.variantId === variantId && item.step === 'services')) {
                    const item = {
                        variantId: variantId,
                        name: productName,
                        price: priceValue,
                        priceFormatted: productPrice,
                        experience: tabs.length > 0 ? (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).querySelector('h4').textContent : '',
                        step: 'services',
                        serviceCategory: serviceCategory
                    };
                    pendingItems.push(item);
                }
            } else {
                pendingItems = pendingItems.filter(item => !(item.variantId === variantId && item.step === 'services'));
            }

            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
            syncServiceCheckboxes();
            if (this.checked) {
                await addExperienceVariantToCart(
                    variantId,
                    tabs.length > 0 ? (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).querySelector('h4').textContent : '',
                    productItem || this
                );
            } else {
                await removeExperienceVariantFromCart(variantId, { openDrawer: false, triggerElement: productItem || this });
            }
        });
    });

    document.querySelectorAll('.distribution-master-checkbox').forEach(masterCheckbox => {
        masterCheckbox.addEventListener('change', async function() {
            const distributionItem = this.closest('.service-item.service-distribution-options');
            if (!distributionItem) return;

            const radios = Array.from(distributionItem.querySelectorAll('.distribution-radio'));
            if (this.checked) {
                const selectedRadio = radios.find(radio => radio.checked);
                const firstAvailableRadio = selectedRadio || radios.find(radio => Boolean(radio.getAttribute('data-variant-id')));
                if (!firstAvailableRadio) {
                    this.checked = false;
                    return;
                }

                if (!firstAvailableRadio.checked) {
                    firstAvailableRadio.checked = true;
                    firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
                } else {
                    syncDistributionMasterCheckboxes();
                }
            } else {
                let hadCheckedPackage = false;
                radios.forEach(radio => {
                    if (radio.checked) {
                        radio.checked = false;
                        hadCheckedPackage = true;
                    }
                });

                if (hadCheckedPackage) {
                    showLoadingSpinner();
                    pendingItems = pendingItems.filter(item => !(item.step === 'services' && item.serviceKind === 'distribution'));
                    localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
                    updateCart();
                    await removeDistributionExperienceVariants({ openDrawer: false, triggerElement: distributionItem });
                }
                syncDistributionRadios();
            }
        });
    });

    // CV Distribution package radios (main service branch)
    document.querySelectorAll('.distribution-radio').forEach(radio => {
        radio.addEventListener('change', async function() {
            if (!this.checked) return;

            const variantId = this.getAttribute('data-variant-id');
            const packagePriceCents = Number(this.getAttribute('data-price-cents') || 0);
            const packageLabel = this.getAttribute('data-package-label') || 'CV Distribution';
            const activeCurrency = document.querySelector('.bucks-selected')?.innerText || 'AED';
            const packagePriceFromRow = this.closest('.distribution-option')?.querySelector('.price')?.textContent?.trim() || '';
            const priceValue = packagePriceCents > 0 ? (packagePriceCents / 100) : parseCurrencyValue(packagePriceFromRow || '', activeCurrency);
            const currencySymbol = activeCurrency === 'AED' ? 'Dhs.' : activeCurrency;
            const packagePrice = packagePriceFromRow || `${currencySymbol} ${priceValue.toFixed(2)}`;

            // Keep only one distribution package in services at a time
            pendingItems = pendingItems.filter(item => !(item.step === 'services' && item.serviceKind === 'distribution'));

            if (variantId) {
                const item = {
                    variantId: variantId,
                    name: packageLabel,
                    price: priceValue,
                    priceFormatted: packagePrice,
                    experience: tabs.length > 0 ? (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).querySelector('h4').textContent : '',
                    step: 'services',
                    serviceCategory: 'main',
                    serviceKind: 'distribution'
                };
                pendingItems.push(item);
            }

            localStorage.setItem('experienceCart', JSON.stringify(pendingItems));
            updateCart();
            syncDistributionRadios();
            await removeDistributionExperienceVariants({ openDrawer: false, triggerElement: this.closest('.service-item') || this });
            await addExperienceVariantToCart(
                variantId,
                tabs.length > 0 ? (Array.from(tabs).find(tab => tab.classList.contains('selected')) || tabs[0]).querySelector('h4').textContent : '',
                this.closest('.service-item') || this
            );
        });
    });

    // Step navigation logic
    checkoutButtons.forEach(button => {
        button.addEventListener('click', async function(e) {
            if (!layout.classList.contains('cstm-services-step')) {
                // Move from Step 1 to Step 2
                layout.classList.add('cstm-services-step');
                updateCart();
                updateExperienceStepper(2);
                return;
            } else if (!layout.classList.contains('cstm-upload')) {
                // Move from Step 2 to Step 3 (Upload)
                const activeServiceGroup = document.querySelector('.service-group.active');
                const selectedMainCount = activeServiceGroup ? activeServiceGroup.querySelectorAll('.service-item[data-service-category=\"main\"] input:checked').length : 0;
                if (selectedMainCount === 0) {
                    e.preventDefault();
                    alert(window.locale === 'ar' ? 'الرجاء اختيار خدمة رئيسية واحدة على الأقل للمتابعة.' : 'Please select at least one Main Service to proceed.');
                    return;
                }
                layout.classList.add('cstm-upload');
                checkoutButtons.forEach(btn => {
                    btn.textContent = proceedCheckoutText;
                });
                updateCart();
                updateExperienceStepper(3);
                document.querySelector('.cv-upload-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            } else {
                // Final checkout after Step 3
                if (pendingItems.length === 0) {
                    e.preventDefault();
                    alert(window.locale === 'ar' ? 'الرجاء تحديد خدمة واحدة على الأقل للمتابعة.' : 'Please select at least one service to proceed.');
                    return;
                }
                checkoutButtons.forEach(btn => {
                    btn.textContent = proceedCheckoutText;
                    btn.classList.add('is-loading');
                });
                updateExperienceStepper(3);
                showLoadingSpinner();
                try {
                    await cartSyncQueue.catch(() => null);
                    const syncedCart = await syncCartWithShopify();
                    if (!syncedCart || !Array.isArray(syncedCart.items) || syncedCart.items.length === 0) {
                        alert(window.locale === 'ar'
                            ? 'تعذر مزامنة السلة مع شوبيفاي. حاول مرة أخرى.'
                            : 'Failed to sync cart with Shopify. Please try again.');
                        checkoutButtons.forEach(btn => btn.classList.remove('is-loading'));
                        return;
                    }

                    if (uploadedCvFileName) {
                        const hasUploadLink = syncedCart.items.some(item => {
                            if (!item.properties) return false;
                            const uploadedCvValue = item.properties['Uploaded CV'];
                            return typeof uploadedCvValue === 'string' && uploadedCvValue.indexOf('/uploads/') > -1;
                        });

                        if (!hasUploadLink) {
                            alert(window.locale === 'ar'
                                ? 'لم يتم حفظ ملف السيرة الذاتية بشكل صحيح. يرجى إعادة رفع الملف والمحاولة مرة أخرى.'
                                : 'The CV file was not attached correctly. Please re-upload and try again.');
                            checkoutButtons.forEach(btn => btn.classList.remove('is-loading'));
                            return;
                        }
                    }

                    await syncUploadAttribute();
                    redirectToCheckout();
                } catch (error) {
                    console.error('Checkout sync error:', error);
                    alert(window.locale === 'ar'
                        ? 'حدث خطأ أثناء تجهيز الطلب للدفع. حاول مرة أخرى.'
                        : 'An error occurred while preparing checkout. Please try again.');
                    checkoutButtons.forEach(btn => btn.classList.remove('is-loading'));
                }
            }
        });
    });

    // Handle Services Back button (Step 2 to Step 1)
    if (servicesBackButton) {
        servicesBackButton.addEventListener('click', function() {
            layout.classList.remove('cstm-services-step', 'cstm-upload');
            checkoutButtons.forEach(btn => {
                btn.textContent = proceedNextStepText;
            });
            updateExperienceStepper(1);
        });
    }

    if (uploadBackButton) {
        uploadBackButton.addEventListener('click', function() {
            layout.classList.remove('cstm-upload');
            checkoutButtons.forEach(btn => {
                btn.textContent = proceedNextStepText;
            });
            updateExperienceStepper(2);
            document.querySelector('.services-step')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    // Mobile scroll for experience tabs
    const experienceTabs = document.querySelectorAll('.cstm-exper-block .tabs .tab');
    experienceTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            if (window.innerWidth <= 768) {
                const cartElement = document.querySelector('.cstm-experience .services');
                if (cartElement) {
                    cartElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });
    });

    // Replace all price parsing logic with this universal function
    function parseCurrencyValue(priceText, currencyCode) {
    console.log('Input priceText:', priceText, 'Currency:', currencyCode); // Debug log

    // Step 1: Remove currency prefix (Dhs.) and any whitespace
    let normalizedText = priceText.replace(/^Dhs\.\s*/i, '').trim();
    console.log('After removing Dhs. and whitespace:', normalizedText); // Debug log

    // Step 2: Remove any remaining non-numeric characters except digits, commas, and dots
    normalizedText = normalizedText.replace(/[^\d,.]/g, '');
    console.log('After removing non-numeric:', normalizedText); // Debug log

    if (currencyCode === 'AED') {
        // For AED (e.g., 1,065.03), treat comma as thousand separator and dot as decimal
        normalizedText = normalizedText.replace(/,/g, '');
        console.log('After AED comma removal:', normalizedText); // Debug log
    } else {
        // Determine if it's a European format (e.g., 1.234,56) or international (e.g., 1,234.56)
        const hasCommaDecimal = /,\d{2}$/.test(normalizedText); // Ends with , and two digits
        const hasDotDecimal = /\.\d{2}$/.test(normalizedText); // Ends with . and two digits

        if (hasCommaDecimal) {
            // European format: replace dots with nothing, comma with dot
            normalizedText = normalizedText.replace(/\./g, '').replace(',', '.');
            console.log('After European format handling:', normalizedText); // Debug log
        } else if (hasDotDecimal) {
            // International format: remove commas
            normalizedText = normalizedText.replace(/,/g, '');
            console.log('After international format handling:', normalizedText); // Debug log
        } else {
            // Fallback: keep only the last separator as decimal
            const lastSeparator = Math.max(
                normalizedText.lastIndexOf(','),
                normalizedText.lastIndexOf('.')
            );
            if (lastSeparator > -1) {
                normalizedText =
                    normalizedText.substring(0, lastSeparator).replace(/[.,]/g, '') +
                    normalizedText.substring(lastSeparator).replace(',', '.');
            } else {
                normalizedText = normalizedText.replace(/[.,]/g, '');
            }
            console.log('After fallback handling:', normalizedText); // Debug log
        }
    }

    const parsedValue = parseFloat(normalizedText);
    console.log('Parsed Value:', parsedValue); // Debug log
    return isNaN(parsedValue) ? 0 : parsedValue;
}

    syncServiceCheckboxes();
    syncDistributionRadios();

    // Tooltip: open large popup modal on click/tap (Experience Level page).
    const experienceTooltipIcons = document.querySelectorAll('.cstm-experience .info-icon');
    if (experienceTooltipIcons.length > 0) {
        const escapeHtml = (value) => {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            };
            return String(value || '').replace(/[&<>"']/g, (char) => map[char]);
        };

        const overlay = document.createElement('div');
        overlay.className = 'cstm-tooltip-modal-overlay';
        overlay.innerHTML = `
            <div class="cstm-tooltip-modal" role="dialog" aria-modal="true" aria-labelledby="cstm-tooltip-modal-title">
                <button type="button" class="cstm-tooltip-modal-close" aria-label="Close popup">&times;</button>
                <h3 id="cstm-tooltip-modal-title" class="cstm-tooltip-modal-title"></h3>
                <h4 class="cstm-tooltip-modal-subtitle"></h4>
                <div class="cstm-tooltip-modal-body"></div>
            </div>
        `;
        document.body.appendChild(overlay);

        const closeButton = overlay.querySelector('.cstm-tooltip-modal-close');
        const titleNode = overlay.querySelector('.cstm-tooltip-modal-title');
        const subtitleNode = overlay.querySelector('.cstm-tooltip-modal-subtitle');
        const bodyNode = overlay.querySelector('.cstm-tooltip-modal-body');

        const closeTooltipModal = () => {
            overlay.classList.remove('is-visible');
            document.body.classList.remove('cstm-tooltip-modal-open');
        };

        const openTooltipModal = (serviceName, tooltipText) => {
            const cleanServiceName = (serviceName || 'Service details').trim();
            const cleanTooltipText = (tooltipText || '').trim();
            if (!cleanTooltipText) return;

            titleNode.textContent = cleanServiceName;
            subtitleNode.textContent = `Looking to order a ${cleanServiceName}?`;
            bodyNode.innerHTML = cleanTooltipText
                .split(/\n+/)
                .map((line) => line.trim())
                .filter(Boolean)
                .map((line) => `<p>${escapeHtml(line)}</p>`)
                .join('');

            overlay.classList.add('is-visible');
            document.body.classList.add('cstm-tooltip-modal-open');
            closeButton.focus();
        };

        closeButton.addEventListener('click', closeTooltipModal);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) closeTooltipModal();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
                closeTooltipModal();
            }
        });

        experienceTooltipIcons.forEach(icon => {
            if (!icon.hasAttribute('tabindex')) icon.setAttribute('tabindex', '0');
            if (!icon.hasAttribute('role')) icon.setAttribute('role', 'button');
            if (!icon.hasAttribute('aria-label')) icon.setAttribute('aria-label', 'More info');

            const serviceRow = icon.closest('.service-item');
            const serviceNameNode = serviceRow ? serviceRow.querySelector('.service-name') : null;
            const optionNameNode = icon.closest('.distribution-option')?.querySelector('.distribution-option-name');
            const tooltipNode = icon.querySelector('.tooltip');
            if (tooltipNode) {
                tooltipNode.setAttribute('aria-hidden', 'true');
            }

            const handleOpen = (event) => {
                event.preventDefault();
                event.stopPropagation();
                const serviceName = optionNameNode
                    ? optionNameNode.textContent
                    : (serviceNameNode ? serviceNameNode.textContent : 'Service details');
                const tooltipText = tooltipNode ? tooltipNode.textContent : '';
                openTooltipModal(serviceName, tooltipText);
            };

            icon.addEventListener('click', handleOpen);
            icon.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleOpen(e);
                }
            });
        });
    }
});
